<template>
  <div class="col-12 row q-col-gutter-x-sm items-center">
    <model-form-select
      :field="deliveryLocationsField"
      class="col-8"
      :label="`${(conditional.conditionsRequirements[excludeDeliveryLocationField] ? 'Exclude' : 'Include')} Delivery Locations`"
      value-type="Array"
      :options="deliveryLocations.data"
      option-label="name"
      option-value="id"
      map-options
      emit-value
      multiple
      use-chips
      clearable
      :rules="[
        val => !!val || 'Field is required',
        val => val.length > 0 || 'Must select at least one Delivery Type'
      ]"
    />
    <model-form-toggle
      :field="`conditionsRequirements.${excludeDeliveryLocationField}`"
      class="col-4 q-mb-md"
      label="Exclude"
      value-type="Boolean"
    />
  </div>
</template>

<script>
import { CONDITIONS_REQUIREMENTS } from 'src/models/booking-fee-type/BookingFeeType'

export default {
  name: 'DeliveryLocationConditionForm',
  configuration: ['deliveryLocations'],
  props: {
    conditional: {
      type: Object,
      required: true
    },
    deliveryLocationsField: {
      type: String,
      default: CONDITIONS_REQUIREMENTS.DELIVERY_LOCATIONS
    },
    excludeDeliveryLocationField: {
      type: String,
      default: CONDITIONS_REQUIREMENTS.EXCLUDE_DELIVERY_LOCATIONS
    }
  }
}

</script>
